import React, { useState } from 'react'
import { LEGACY_REACTIONS, CONTENT_TYPE_PROMPTS } from '../../constants/reactions'
import ReactionIcon from './ReactionIcon'

/**
 * ReactionBar — six reaction buttons for the current user.
 *
 * Shows fixed order. Active reactions are filled with warm color.
 * Tapping a reaction toggles it on/off.
 * After adding a reaction, shows an optional note input.
 */
function ReactionBar({
  contentType,
  myReactions = [],
  togglingType = null,
  onToggle,
  onUpdateNote,
  reactions = [],
}) {
  const [noteTarget, setNoteTarget] = useState(null)
  const [noteText, setNoteText] = useState('')

  const prompt = CONTENT_TYPE_PROMPTS[contentType] || 'How did this reach you?'

  const handleClick = async (type) => {
    const isActive = myReactions.includes(type)

    if (isActive) {
      await onToggle(type)
      setNoteTarget(null)
    } else {
      const result = await onToggle(type)
      if (result && result.action === 'added') {
        setNoteTarget(type)
        setNoteText('')
      }
    }
  }

  const handleNoteSend = async () => {
    if (!noteText.trim() || !noteTarget) {
      setNoteTarget(null)
      setNoteText('')
      return
    }

    // Find the reaction ID for this type from the reactions list
    const myReaction = reactions.find(
      (r) => r.reaction_type === noteTarget
    )
    if (myReaction && onUpdateNote) {
      await onUpdateNote(myReaction.id, noteText.trim())
    }

    setNoteTarget(null)
    setNoteText('')
  }

  return (
    <div className="reaction-bar">
      <p className="reaction-bar-prompt">{prompt}</p>
      <div className="reaction-bar-buttons">
        {LEGACY_REACTIONS.map((reaction) => {
          const isActive = myReactions.includes(reaction.type)
          const isToggling = togglingType === reaction.type

          return (
            <button
              key={reaction.type}
              className={`reaction-bar-btn ${isActive ? 'active' : ''} ${isToggling ? 'toggling' : ''}`}
              onClick={() => handleClick(reaction.type)}
              disabled={isToggling}
              title={reaction.description}
              style={{
                '--reaction-color': reaction.color,
                '--reaction-color-light': reaction.colorLight,
              }}
            >
              <ReactionIcon
                type={reaction.type}
                state={isActive ? 'active' : 'idle'}
                size={18}
              />
              <span className="reaction-bar-label">{reaction.label}</span>
            </button>
          )
        })}
      </div>

      {/* Note input — appears after adding a reaction */}
      {noteTarget && (
        <div className="reaction-note-input">
          <input
            type="text"
            placeholder="Add a personal note (optional)..."
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleNoteSend()
              if (e.key === 'Escape') {
                setNoteTarget(null)
                setNoteText('')
              }
            }}
            maxLength={500}
            autoFocus
          />
          <button
            onClick={handleNoteSend}
            className="reaction-note-dismiss"
          >
            {noteText.trim() ? 'Send' : 'Skip'}
          </button>
        </div>
      )}
    </div>
  )
}

export default ReactionBar
